import type { PagesConfig } from '#types/config/pages'
import type { RecursivePartial } from '#types/utils'

export default {
  orderNumberLengths: (() => [8, 13, 16]) as unknown as number[],
  showZipCodeInput: true
} satisfies RecursivePartial<PagesConfig['orderStatus']>
